import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { isMobile } from 'react-device-detect';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import { range } from '../../../../utils/utils';
import { NOT_IN_HAND_FILTER } from '../playerFilters';
import { SeatedPlayerMedalDisplay } from './seatedPlayerMedalDisplay';
/**
 * Fudge factor for the amount of pixel width that should be enough for anything that will show in a player's
 * chips or status display, anything like 'ALL-IN' or '535.8K' or 'Stand' or 'SitOut'.
 * The amount of visible width above this amount will determine how to render the medals and how much space is available for them.
 */
const CHIPS_OR_STATUS_RESERVED_PX = 80;
const MEDAL_SPACING_PX = 14;
export const SeatedPlayerMedalsContainer = ({ seatIndex }) => {
    const isSeatedPlayerIn = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.isIn);
    const numVisibleMedals = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.visibleMedals.length || 0);
    const seatDimensions = useAppSelector((state) => state.gameDimensions.seatDimensions, shallowEqual);
    const usernameBarBounds = useAppSelector((state) => state.gameDimensions.usernameBarBounds, shallowEqual);
    if (!numVisibleMedals || !usernameBarBounds || !seatDimensions) {
        return null;
    }
    if (seatDimensions.w < CHIPS_OR_STATUS_RESERVED_PX) {
        return null;
    }
    let numMedalColumns = Math.floor((seatDimensions.w - CHIPS_OR_STATUS_RESERVED_PX) / MEDAL_SPACING_PX);
    if (isMobile) {
        // On mobile, medals can be hard to see clearly, especially when nearly on top of the avatar or crowding towards
        // the chip count display, so limit to one column.
        numMedalColumns = Math.min(1, numMedalColumns);
    }
    if (numMedalColumns <= 0) {
        return null;
    }
    const leftX = Math.round(-usernameBarBounds.w / 2) + 4;
    const bottomY = Math.round(usernameBarBounds.y - usernameBarBounds.h / 2 - 4);
    const numMedalRows = Math.floor((seatDimensions.h / 2 + bottomY) / MEDAL_SPACING_PX);
    if (numMedalRows <= 0) {
        return null;
    }
    const numMedalsToShow = Math.min(numVisibleMedals, numMedalRows * numMedalColumns);
    return (_jsx(Container, { interactiveChildren: false, filters: !isSeatedPlayerIn ? [NOT_IN_HAND_FILTER] : null, children: range(numMedalsToShow).map((i) => {
            const xIndex = i % numMedalColumns;
            const yIndex = Math.floor(i / numMedalColumns);
            return (_jsx(SeatedPlayerMedalDisplay, { seatIndex: seatIndex, visibleMedalIndex: i, x: leftX + xIndex * MEDAL_SPACING_PX, y: bottomY - (1 + yIndex) * MEDAL_SPACING_PX }, i));
        }) }));
};
